import { useSyncExternalStore } from 'react';
import { getServiceStatus, subscribeServiceStatus } from '../utils/serviceStatus';

/** The current reachability of the API: `{ down, since, lastCheckedAt, reason, checking }`. */
export const useServiceStatus = () => useSyncExternalStore(subscribeServiceStatus, getServiceStatus, getServiceStatus);

export default useServiceStatus;
